import { IId, IOrganizationId, TNameTitle } from 'interfaces/common/common';

import { client } from '@api/client';
import { URL } from '@api/urls';

import { IAssetAccess, IAssetAccessRestricted } from '@interfaces/assets/assetAccess';
import { IGetAssetAccessRestrictedDTO, IUpdateAssetAccessDTO } from '@interfaces/assets/dto/assetAccessDTO';
import { IItemsResponse } from '@interfaces/common/response';

const {
	organizationProfile,
	assetAccess,
	assetAccessRestricted,
	assetAccessRestrictedEnable,
	assetAccessRestrictedDisable,
	assetAccessTypes,
	assetAccessVisibilityModes,
	assetAccessResultingTypes,
} = URL;

export const getAssetAccess = ({ id }: IId): Promise<IAssetAccess> => {
	return client.get(`${organizationProfile}/${id}/${assetAccess}`);
};

export const getAssetAccessTypes = (): Promise<TNameTitle[]> => {
	return client.get(`${organizationProfile}/${assetAccessTypes}`);
};

export const getAssetAOVisibilityModes = (): Promise<TNameTitle[]> => {
	return client.get(`${organizationProfile}/${assetAccessVisibilityModes}`);
};

export const getAssetResultingAccessTypes = (): Promise<TNameTitle[]> => {
	return client.get(`${organizationProfile}/${assetAccessResultingTypes}`);
};

export const getAssetAccessRestricted = ({
	id,
	...params
}: IGetAssetAccessRestrictedDTO): Promise<IItemsResponse<IAssetAccessRestricted>> => {
	return client.get(`${organizationProfile}/${id}/${assetAccessRestricted}`, { params });
};

export const updateAssetAccess = ({ id, ...dto }: IUpdateAssetAccessDTO): Promise<void> => {
	return client.post(`${organizationProfile}/${id}/${assetAccess}`, dto);
};

export const enableRestrictedAssetAccess = ({ id, ...dto }: IId & IOrganizationId): Promise<void> => {
	return client.post(`${organizationProfile}/${id}/${assetAccessRestrictedEnable}`, dto);
};

export const disableRestrictedAssetAccess = ({ id, ...dto }: IId & IOrganizationId): Promise<void> => {
	return client.post(`${organizationProfile}/${id}/${assetAccessRestrictedDisable}`, dto);
};
